var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "M63 134h91q.774-.002 1.5-.161.726.16 1.5.161h52a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 1 0 0 14m163 0a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M169 110.333v29.334a11 11 0 0 1-11 11H92a11 11 0 0 1-11-11V81a11 11 0 0 1 11-11h66a11 11 0 0 1 11 11v29.333"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M169 110.333a11 11 0 0 0-11-11h-18.333a14.668 14.668 0 0 1-29.334 0H92a11 11 0 0 0-11 11m88 0v29.334a11 11 0 0 1-11 11H92a11 11 0 0 1-11-11v-29.334m88 0V95.667m-88 14.666V95.667m88 0a11 11 0 0 0-11-11H92a11 11 0 0 0-11 11m88 0V81a11 11 0 0 0-11-11H92a11 11 0 0 0-11 11v14.667"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M169 110.333a11 11 0 0 0-11-11h-18.333a14.668 14.668 0 0 1-29.334 0H92a11 11 0 0 0-11 11m88 0v29.334a11 11 0 0 1-11 11H92a11 11 0 0 1-11-11v-29.334m88 0V95.667m-88 14.666V95.667m88 0a11 11 0 0 0-11-11H92a11 11 0 0 0-11 11m88 0V81a11 11 0 0 0-11-11H92a11 11 0 0 0-11 11v14.667"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M150.1 46.303 139 58.756M124.1 42v16.756zM98 46.303l11.1 12.453zM91 140.743v-18.318m0-5.682V112z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#960145",
  d: "m128.439 126-5.192.016-4.322 7.487 2.586 4.497z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "m128.439 126-5.192.016-4.322 7.487 2.586 4.497z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#960145",
  d: "m134.95 126-5.193.016-4.322 7.487 2.586 4.497z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "m134.95 126-5.193.016-4.322 7.487 2.586 4.497z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#960145",
  d: "M121.928 126H115l3.277 6.008z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "M121.928 126H115l3.277 6.008z"
})));
export default SvgWallet;